import React from 'react';

const LINKS = [
  { href: '#metodo', label: 'Método WITS' },
  { href: '#clase', label: 'La clase' },
  { href: '#docente', label: 'Docente' },
  { href: '#faq', label: 'Preguntas' },
];

/**
 * Sub-nav propia de la landing: reemplaza el header/logo duplicado del
 * diseño original. Sticky justo debajo del TopBar del sitio, alineada a la
 * izquierda; cada link hace scroll suave (scroll-behavior:smooth global) a
 * su sección.
 */
const SectionNav: React.FC = () => {
  return (
    <div className="sticky top-24 z-40 border-b border-white/10 bg-[#0a1030]/80 backdrop-blur-md">
      <div className="mx-auto max-w-7xl px-5">
        <nav className="flex items-center gap-6 overflow-x-auto py-3 text-sm font-medium text-white/60">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap transition-colors hover:text-white"
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default SectionNav;
